import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-path=\"url(#a)\" clip-rule=\"evenodd\"><path d=\"M9.582 2.063a4.5 4.5 0 0 1 6.362 6.363l-.009.01-2.25 2.25a4.5 4.5 0 0 1-6.786-.487.75.75 0 1 1 1.202-.898 3 3 0 0 0 4.524.324L14.87 7.38a3 3 0 0 0-4.243-4.242L9.341 4.417a.75.75 0 0 1-1.057-1.064l1.29-1.282z\"></path><path d=\"M5.925 6.28A4.5 4.5 0 0 1 11.1 7.8a.75.75 0 1 1-1.201.9 3 3 0 0 0-4.524-.325L3.13 10.621a3 3 0 0 0 4.242 4.241l1.278-1.277a.75.75 0 0 1 1.06 1.06l-1.282 1.283-.01.009a4.5 4.5 0 0 1-6.362-6.363l.009-.01 2.25-2.25a4.5 4.5 0 0 1 1.61-1.034\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h18v18H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }